<p-dialog
  #fastVeiculo
  [modal]="true"
  [visible]="true"
  [position]="'top'"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar veículo</span>
      <i class="mdi mdi-car ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row p-2">
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Placa</mat-label>
        <input
          matInput
          type="text"
          (blur)="checkChassiOuPlaca(false)"
          [formControl]="form.get('placa')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('placa').touched && form.get('placa').hasError('required')
        "
      >
        {{ displayMessage.placa.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('placa').touched && form.get('placa').hasError('maxlength')
        "
      >
        {{ displayMessage.placa.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('placa').touched &&
          form.get('placa').hasError('isEmptyValue')
        "
      >
        {{ displayMessage.placa.isEmptyValue }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('placa').touched && form.get('placa').hasError('duplicate')
        "
      >
        {{ displayMessage.placa.duplicate }}
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Chassi</mat-label>
        <input
          matInput
          type="text"
          (blur)="checkChassiOuPlaca(true)"
          [formControl]="form.get('chassi')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('chassi').touched && form.get('chassi').hasError('duplicate')
        "
      >
        {{ displayMessage.chassi.duplicate }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('chassi').touched && form.get('chassi').hasError('duplicate')
        "
      >
        {{ displayMessage.chassi.duplicate }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('chassi').touched && form.get('chassi').hasError('duplicate')
        "
      >
        {{ displayMessage.chassi.duplicate }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('chassi').touched && form.get('chassi').hasError('duplicate')
        "
      >
        {{ displayMessage.chassi.duplicate }}
      </small>
    </div>
    <div class="col-md-2 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Estado</mat-label>
        <input
          matInput
          [value]="
            form.get('estado') ? (form.get('estado').value | uppercase) : ''
          "
          mask="SS"
          type="text"
          [formControl]="form.get('estado')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('estado').touched && form.get('estado').hasError('required')
        "
      >
        {{ displayMessage.estado.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('estado').touched && form.get('estado').hasError('maxlength')
        "
      >
        {{ displayMessage.estado.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('estado').touched &&
          form.get('estado').hasError('isEmptyValue')
        "
      >
        {{ displayMessage.estado.isEmptyValue }}
      </small>
    </div>
    <fast-autocomplete
      #input
      id="field-combustivel"
      placeholder="Combustível"
      required
      [domain_id]="tokenService.getDomain().id"
      class="col-md-4 mt-3"
      [autoFirst]="false"
      displayField="nome"
      (clearSelection)="form.get('combustivel').reset()"
      [value_order]="'nome'"
      [pageValue]="'0'"
      [pageSizeValue]="'10'"
      [control]="form.get('combustivel')"
      [entityService]="combustivelService"
      [actionState]="checkDisponibilidade('POST', '', '/combustiveis')"
      [initDataWithEmpty]="true"
      [messages]="{
        required: 'Combustível é requerido.',
        typeIs: 'Valor inválido',
        isEmptyValue: 'Valor inválido: remova os espaços em branco!'
      }"
      insertType="combustivel"
    ></fast-autocomplete>
    <fast-autocomplete
      #input
      id="field-modelo-veiculo"
      placeholder="Modelo do veículo"
      required
      [domain_id]="tokenService.getDomain().id"
      class="col-md-4 mt-3"
      [autoFirst]="false"
      displayField="nome"
      (clearSelection)="form.get('modelo_veiculo').reset()"
      [value_order]="'nome'"
      [pageValue]="'0'"
      [pageSizeValue]="'10'"
      [control]="form.get('modelo_veiculo')"
      [entityService]="modeloTransporteService"
      [actionState]="checkDisponibilidade('POST', '', '/modelo_veiculos')"
      [initDataWithEmpty]="true"
      [messages]="{
        required: 'Modelo do veículo é requerido.',
        typeIs: 'Valor inválido',
        isEmptyValue: 'Valor inválido: remova os espaços em branco!'
      }"
      insertType="modelo_transporte"
    ></fast-autocomplete>
    <fast-autocomplete
      #input
      id="field-motorista"
      placeholder="Motorista"
      required
      [domain_id]="tokenService.getDomain().id"
      class="col-md-8 mt-3"
      [autoFirst]="false"
      displayField="parceiro.nome_razao_social"
      (clearSelection)="form.get('motorista').reset()"
      [pageValue]="'0'"
      [pageSizeValue]="'10'"
      [domainPath]="'parceiro.domain_id'"
      [control]="form.get('motorista')"
      [entityService]="motoristaService"
      [displayWithEntityFn]="displayFn"
      [actionState]="checkDisponibilidade('POST', '', '/motoristas')"
      [initDataWithEmpty]="true"
      [include]="['parceiro']"
      [messages]="{
        required: 'Motorista é requerido.',
        typeIs: 'Valor inválido',
        isEmptyValue: 'Valor inválido: remova os espaços em branco!'
      }"
      insertType="motorista"
    ></fast-autocomplete>
    <div class="col-md-12 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Descrição</mat-label>
        <input matInput type="text" [formControl]="form.get('descricao')" />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('required')
        "
      >
        {{ displayMessage.descricao.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('maxlength')
        "
      >
        {{ displayMessage.descricao.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('isEmptyValue')
        "
      >
        {{ displayMessage.descricao.isEmptyValue }}
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Tipo de veículo</mat-label>
        <input matInput type="text" [formControl]="form.get('tipo_veiculo')" />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('tipo_veiculo').touched &&
          form.get('tipo_veiculo').hasError('maxlength')
        "
      >
        {{ displayMessage.tipo_veiculo.isEmptyValue }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('tipo_veiculo').touched &&
          form.get('tipo_veiculo').hasError('isEmptyValue')
        "
      >
        {{ displayMessage.tipo_veiculo.isEmptyValue }}
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Tipo rodado</mat-label>
        <input matInput type="text" [formControl]="form.get('tipo_rodado')" />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('tipo_rodado').touched &&
          form.get('tipo_rodado').hasError('maxlength')
        "
      >
        {{ displayMessage.tipo_rodado.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('tipo_rodado').touched &&
          form.get('tipo_rodado').hasError('isEmptyValue')
        "
      >
        {{ displayMessage.tipo_rodado.isEmptyValue }}
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Cor</mat-label>
        <input matInput type="text" [formControl]="form.get('cor')" />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('cor').touched && form.get('cor').hasError('maxlength')"
      >
        {{ displayMessage.cor.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('cor').touched && form.get('cor').hasError('isEmptyValue')
        "
      >
        {{ displayMessage.cor.isEmptyValue }}
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Tara</mat-label>
        <input
          matInput
          (keydown)="validateNumbers($event)"
          type="text"
          [formControl]="form.get('tara')"
        />
      </mat-form-field>
      <small class="p-error" *ngIf="form.get('tara').hasError('max_value')">
        {{ displayMessage.tara.max_value }}
      </small>
      <small class="p-error" *ngIf="form.get('tara').hasError('before_split')">
        {{ displayMessage.tara.before_split }}
      </small>
      <small class="p-error" *ngIf="form.get('tara').hasError('after_split')">
        {{ displayMessage.tara.after_split }}
      </small>
      <small class="p-error" *ngIf="form.get('tara').hasError('errorComma')">
        {{ displayMessage.tara.errorComma }}
      </small>
      <small class="p-error" *ngIf="form.get('tara').hasError('errorDots')">
        {{ displayMessage.tara.errorDots }}
      </small>
      <small class="p-error" *ngIf="form.get('tara').hasError('notNumbers')">
        {{ displayMessage.tara.notNumbers }}
      </small>
      <small class="p-error" *ngIf="form.get('tara').hasError('invalidNumber')">
        {{ displayMessage.tara.invalidNumber }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('tara').hasError('existSpecialChar')"
      >
        {{ displayMessage.tara.existSpecialChar }}
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Capacidade (Kg)</mat-label>
        <input
          matInput
          (keydown)="validateNumbers($event)"
          type="text"
          [formControl]="form.get('capacidade_kg')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_kg').hasError('max_value')"
      >
        {{ displayMessage.capacidade_kg.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_kg').hasError('before_split')"
      >
        {{ displayMessage.capacidade_kg.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_kg').hasError('after_split')"
      >
        {{ displayMessage.capacidade_kg.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_kg').hasError('errorComma')"
      >
        {{ displayMessage.capacidade_kg.errorComma }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_kg').hasError('errorDots')"
      >
        {{ displayMessage.capacidade_kg.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_kg').hasError('notNumbers')"
      >
        {{ displayMessage.capacidade_kg.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_kg').hasError('invalidNumber')"
      >
        {{ displayMessage.capacidade_kg.invalidNumber }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_kg').hasError('existSpecialChar')"
      >
        {{ displayMessage.capacidade_kg.existSpecialChar }}
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Capacidade (m³)</mat-label>
        <input
          matInput
          (keydown)="validateNumbers($event)"
          type="text"
          [formControl]="form.get('capacidade_m3')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_m3').hasError('max_value')"
      >
        {{ displayMessage.capacidade_m3.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_m3').hasError('before_split')"
      >
        {{ displayMessage.capacidade_m3.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_m3').hasError('after_split')"
      >
        {{ displayMessage.capacidade_m3.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_m3').hasError('errorComma')"
      >
        {{ displayMessage.capacidade_m3.errorComma }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_m3').hasError('errorDots')"
      >
        {{ displayMessage.capacidade_m3.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_m3').hasError('notNumbers')"
      >
        {{ displayMessage.capacidade_m3.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_m3').hasError('invalidNumber')"
      >
        {{ displayMessage.capacidade_m3.invalidNumber }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('capacidade_m3').hasError('existSpecialChar')"
      >
        {{ displayMessage.capacidade_m3.existSpecialChar }}
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Ano do modelo</mat-label>
        <input
          matInput
          (keydown)="validateOnlyNumbers($event)"
          type="text"
          [formControl]="form.get('ano_modelo')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('ano_modelo').hasError('minlength')"
      >
        {{ displayMessage.ano_modelo.minlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_modelo').hasError('maxlength')"
      >
        {{ displayMessage.ano_modelo.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_modelo').hasError('max_value')"
      >
        {{ displayMessage.ano_modelo.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_modelo').hasError('before_split')"
      >
        {{ displayMessage.ano_modelo.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_modelo').hasError('after_split')"
      >
        {{ displayMessage.ano_modelo.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_modelo').hasError('errorComma')"
      >
        {{ displayMessage.ano_modelo.errorComma }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_modelo').hasError('errorDots')"
      >
        {{ displayMessage.ano_modelo.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_modelo').hasError('notNumbers')"
      >
        {{ displayMessage.ano_modelo.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_modelo').hasError('invalidNumber')"
      >
        {{ displayMessage.ano_modelo.invalidNumber }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_modelo').hasError('existSpecialChar')"
      >
        {{ displayMessage.ano_modelo.existSpecialChar }}
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Ano de fabricação</mat-label>
        <input
          matInput
          (keydown)="validateOnlyNumbers($event)"
          type="text"
          [formControl]="form.get('ano_fabricacao')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('ano_fabricacao').hasError('minlength')"
      >
        {{ displayMessage.ano_fabricacao.minlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_fabricacao').hasError('maxlength')"
      >
        {{ displayMessage.ano_fabricacao.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_fabricacao').hasError('max_value')"
      >
        {{ displayMessage.ano_fabricacao.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_fabricacao').hasError('before_split')"
      >
        {{ displayMessage.ano_fabricacao.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_fabricacao').hasError('after_split')"
      >
        {{ displayMessage.ano_fabricacao.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_fabricacao').hasError('errorComma')"
      >
        {{ displayMessage.ano_fabricacao.errorComma }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_fabricacao').hasError('errorDots')"
      >
        {{ displayMessage.ano_fabricacao.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_fabricacao').hasError('notNumbers')"
      >
        {{ displayMessage.ano_fabricacao.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_fabricacao').hasError('invalidNumber')"
      >
        {{ displayMessage.ano_fabricacao.invalidNumber }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('ano_fabricacao').hasError('existSpecialChar')"
      >
        {{ displayMessage.ano_fabricacao.existSpecialChar }}
      </small>
    </div>
    <div class="col-md-4 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>ANTT</mat-label>
        <input matInput type="text" [formControl]="form.get('antt')" />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('antt').touched && form.get('antt').hasError('maxlength')
        "
      >
        {{ displayMessage.antt.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('antt').touched && form.get('antt').hasError('isEmptyValue')
        "
      >
        {{ displayMessage.antt.isEmptyValue }}
      </small>
    </div>
    <div class="col-md-4 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Renavam</mat-label>
        <input matInput type="text" [formControl]="form.get('renavam')" />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('renavam').touched &&
          form.get('renavam').hasError('maxlength')
        "
      >
        {{ displayMessage.renavam.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('renavam').touched &&
          form.get('renavam').hasError('isEmptyValue')
        "
      >
        {{ displayMessage.renavam.isEmptyValue }}
      </small>
    </div>
    <div class="col-md-4 mt-3">
      <mat-form-field appearance="outline" color="primary" class="width-100">
        <mat-label>Vencimento do extintor</mat-label>
        <input
          [id]="ID_FIELD_DTVENCEXT"
          matInput
          appFormatData
          (focus)="onFocus($event, true)"
          (blur)="
            focusElement === ID_DTPICKER_VENCEXT ? null : onFocus(null, false)
          "
          [formControl]="form.get('vencimento_extintor')"
          [matDatepicker]="dataPicker"
        />
        <mat-datepicker-toggle
          *ngIf="
            inputElementDtVencExt
              ? inputElementDtVencExt
              : !form.get('vencimento_extintor').value
              ? focusElement === ID_FIELD_DTVENCEXT ||
                focusElement === ID_DTPICKER_VENCEXT
              : focusElement === ID_FIELD_DTVENCEXT ||
                form.get('vencimento_extintor').value
          "
          (click)="onFocus({ target: { id: ID_DTPICKER_VENCEXT } })"
          (mouseover)="onFocus({ target: { id: ID_DTPICKER_VENCEXT } })"
          (mouseout)="onFocus(null)"
          matSuffix
          [for]="dataPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker
          #dataPicker
          color="primary"
          (closed)="onFocus(null, false)"
        ></mat-datepicker>
      </mat-form-field>
      <small
        class="p-error"
        id="error-data-nascimento"
        *ngIf="form.get('vencimento_extintor').hasError('matDatepickerParse')"
      >
        Esta data é invalida.
      </small>
      <small
        class="p-error"
        id="error-data-nascimento"
        *ngIf="form.get('vencimento_extintor').hasError('invalidDate')"
      >
        Data não pode ser posterior a atual
      </small>
      <small
        class="p-error"
        id="error-data-nascimento"
        *ngIf="form.get('vencimento_extintor').hasError('isEmptyValue')"
      >
        Valor inválido remova os espaços em branco
      </small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        (click)="dialogRef.close()"
        label="Cancelar"
        [disabled]="loading"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
